/**
 * Shared workflow types used by both workflow/types.ts and workflowsSortAndFilters.ts
 * This file breaks the circular dependency between them.
 * Only ENUMS are shared. Interfaces stay in their original files because they have different structures.
 */

export enum EntityType {
    Invoice = 'Invoice',
    Customer = 'Customer',
    PaymentPlanInstallment = 'Payment Plan Installment'
}

export const entityTypeValues = [EntityType.Invoice, EntityType.Customer];

export enum WorkflowDefinitionType {
    Communication = 'Communication'
}

export enum WorkflowStateType {
    Communication = 'Communication',
    Collection = 'Collection',
    PhoneCall = 'PhoneCall',
    PaymentSchedule = 'PaymentSchedule',
}

export enum ReminderType {
    Overdue = 'Overdue',
    NotDue = 'Not due'
}

export const reminderTypeValues = [
    ReminderType.Overdue,
    ReminderType.NotDue
];

export const reminderAutomationValues = [
    'Automatic',
    'Manual'
];

export enum TimingOrientation {
    DueDate = 'Due Date',
    CreateDate = 'Create Date',
    LastAction = 'Last Action'
}

export const timingOrientationValues = [
    TimingOrientation.CreateDate,
    TimingOrientation.DueDate,
    TimingOrientation.LastAction,
];

export enum WorkflowTransitionContent {
    TransitionForm = 'TransitionForm'
}

export enum AdditionalContent {
    LinkTypeSelection = 'LinkTypeSelection'
}

export enum LinkType {
    FirstNotDue = '1st pre-reminder',
    FirstOverdue = '1st overdue reminder',
    NextState = 'Next state'
}
